import { RequestInstance } from "../../../utils/request";

export const contractWalletRechargePage = new RequestInstance({
  method: "get",
  url: "/v2/contract/wallet/recharge/flow/page",
});

export const contractWalletRechargeAdd = new RequestInstance({
  method: "post",
  url: "/v2/contract/wallet/recharge/flow/add",
});

export const tenantPage = new RequestInstance({
  method: "get",
  url: "/v2/tenant/page",
});

export const contractBillPage = new RequestInstance({
  method: "get",
  url: "/v2/contract/bill/page",
});

export const contractWalletUseFlowPage = new RequestInstance({
  method: "get",
  url: "/v2/contract/wallet/use/flow/page",
});

export const contractWalletQuitPage = new RequestInstance({
  method: "get",
  url: "/v2/contract/wallet/quit/flow/page",
});

export const financeManageStatistics = new RequestInstance({
  method: "get",
  url: "/v2/finance/manage/statistics",
});

export const fileInfoRemove = new RequestInstance({
  method: "post",
  url: "/v2/file/info/remove_by_id",
});

export const fileListResource = new RequestInstance({
  method: "get",
  url: "/v2/file/list/by/resource",
});
